import React from 'react'

import { OptOutPage } from '../OptOutPage'

export const SmsOptOut: React.FC = () => {
  return <OptOutPage channel="sms" />
}
